const animateComponent = (ref, animationClass, duration) => {
  const animationEndHandler = () => {
    ref.$el.classList.remove(animationClass)
  }
  animationEndHandler()
  ref.$el.removeEventListener('animationend', animationEndHandler)
  ref.$el.classList.add(animationClass)
  ref.$el.addEventListener('animationend', animationEndHandler)
}

export default animateComponent
